module.exports = "/images/ht.svg?2f8acbbba0f25760727c0e53e547b424";